import { render, staticRenderFns } from "./StandardReportForm.vue?vue&type=template&id=3727952d&scoped=true"
import script from "./StandardReportForm.vue?vue&type=script&lang=js"
export * from "./StandardReportForm.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/_appointment-report.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./StandardReportForm.vue?vue&type=style&index=1&id=3727952d&prod&lang=scss&scoped=true"
import style2 from "./StandardReportForm.vue?vue&type=style&index=2&id=3727952d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3727952d",
  null
  
)

export default component.exports